import React, { useEffect, useRef } from 'react';

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

// Carrega o script do Cloudflare Turnstile só quando um widget é montado —
// nunca no load da página, e nunca se o captcha não estiver configurado
// (siteKey vazio). Mantém uma única cópia do script na página mesmo com
// vários widgets (register e forgot-password podem coexistir em navegação
// rápida entre abas).
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve();
  if (window.__turnstileLoading) return window.__turnstileLoading;
  window.__turnstileLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return window.__turnstileLoading;
}

// Widget de "prova de humano" do Cloudflare Turnstile. Some por completo
// quando siteKey é null — é assim que o resto do produto trata features
// desligadas no backend (Stripe, Telegram, IA): ausente até configurado,
// nunca um erro visível ao utilizador.
const CaptchaWidget = ({ siteKey, onVerify, onExpire }) => {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!siteKey) return;
    let cancelled = false;

    loadTurnstile().then(() => {
      if (cancelled || !containerRef.current || !window.turnstile) return;
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        theme: 'dark',
        callback: onVerify,
        'expired-callback': () => onExpire?.(),
        'error-callback': () => onExpire?.(),
      });
    }).catch(() => {
      // Script bloqueado (ad-blocker, rede) — o formulário segue sem
      // captcha em vez de travar quem quer só criar conta.
    });

    return () => {
      cancelled = true;
      if (widgetIdRef.current && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteKey]);

  if (!siteKey) return null;

  return <div ref={containerRef} className="flex justify-center" data-testid="captcha-widget" />;
};

export default CaptchaWidget;
